<!-- NOTE: DONT DELETE THIS FOR NOW, so we easy change this on files
OLD REVAMP COMPONENTE: import SelectionControllersSwitch from '@/components/generic/selectionControllers/Switch'
-->
<template>
	<div
	class="switch-wrapper"
	:class="[{ 'active': isActive, 'disabled': disabled }]"
	@click.stop="emit('clicked', !isActive)">
		<div class="switch-bar"/>
		<div class="switch-ball"/>
	</div>
</template>

<script setup>
/* Vue */
import { computed, defineAsyncComponent } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* mapGetters */
const { getMobileAppState } = mapGetters()

/* Emmitters */
const emit = defineEmits(['clicked'])

/** props received
@isActive {Boolean} - prop to trigger isActive styles
@disabled {Boolean} - prop to apply disabled styles
*/
const props = defineProps({
	isActive: Boolean,
	disabled: Boolean
})
</script>

<style lang="scss" scoped>
.switch-wrapper {
	width: 64px;
	height: 32px;
	position: relative;
	cursor: pointer;

	.switch-bar {
		width: 64px;
		height: 32px;
		border-radius: 24px;
		border: 1px solid var(--secondary-light-1);
		background-color: var(--secondary-light-4);
		transition: all 0.2s ease-in-out;
	}

	.switch-ball {
		width: 25.6px;
		height: 25.6px;
		top: 3.2px;
		left: 3.2px;
		position: absolute;
		border-radius: 50%;
		box-shadow: 1px 3px 7px rgba(0, 0, 0, 0.24);
		transition: all 0.2s ease-in-out;
		overflow: hidden;

		background-color: var(--secondary);

		.background {
			width: 20px;
			height: 20px;
		}
	}

	&.active {
		.switch-bar {
			background-color: var(--positive);
			border: 1px solid transparent;
		}

		.switch-ball {
			left: calc(64px - 28.8px);

			background-color: var(--secondary-light-4);
		}
	}

	&.disabled {
		pointer-events: none;
		cursor: default;
		opacity: 0.3;
	}
}
</style>
